import moment from 'moment';
import { BinMonitoringChart } from './device-monitoring-chart';

const MAX_DAYS_SHOWN = 2;

class SiloDeviceMonitoringChart extends BinMonitoringChart {
  constructor() {
    super();
    const now = new Date();
    this.start = moment(now).utc().subtract(1, 'day').format();
    this.end = moment(now).utc().format();
  }

  _disableNextButton({ startMoment, nowMoment }) {
    return nowMoment.diff(startMoment, 'days') <= 2;
  }

  _getLayerNames() {
    return ['levels'];
  }

  _prevWeek() {
    this.start = moment(this.start).utc().subtract(1, 'day').format();
    if (moment(this.end).diff(moment(this.start), 'day') > MAX_DAYS_SHOWN) {
      this.end = moment(this.end).utc().subtract(1, 'day').format();
    }
  }

  _nextWeek() {
    const startMoment = moment(this.start);
    const endMoment = moment(this.end);
    const endDiff = moment(new Date()).diff(endMoment, 'days');
    const startDiff = moment(new Date()).diff(startMoment, 'days');

    if (endDiff <= 1) {
      if (startDiff > 1) {
        this.start = startMoment.utc().add(1, 'day').format();
      }
      return;
    }

    this.start = startMoment.utc().add(1, 'day').format();
    this.end = endMoment.utc().add(1, 'day').format();
  }
}

window.customElements.define('silo-device-monitoring-chart', SiloDeviceMonitoringChart);
